import React, { Component, useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { SITE_NAME } from "../config/AppConfig";
import Header from "./../component/Header";
import Footer from "./../component/Footer";
import StoreSkeleton from "./../component/StoreSkeleton";
import $ from "jquery";
import { API_BASE_URL, IMAGE_URL } from "../utils/app_url";
import { useLanguage } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import { NotificationManager } from "react-notifications";
import StoreHeartIcon from "../component/StoreHeartIcon";

const fairImg = require("./../assets/img/trade1.png");
const wishImg = require("./../assets/img/wishlist-icon2.svg").default;

const FairTrade = () => {
  const { user } = useAuth();
  const { selectedLanguage, langJson } = useLanguage();
  // const {CategoryName, SubcategoryName} = useParams();
  const { slugName } = useParams();
  const location = useLocation();

  const [allDetails, setAllDetails] = useState();
  const [loading, setLoading] = useState(true);
  const [responseStatus, setResponseStatus] = useState("");
  const [openModal, setOpenModal] = useState();
  const [storeWishlistLoadingId, setStoreWishlistLoadingId] = useState(null);

  const fetchStores = async () => {
    setLoading(true);
    try {
      let headers = {
        "Content-Type": "application/json",
      };
      if (user) {
        headers.Authorization = `Bearer ${user.authorisation.token}`;
      }
      const response = await fetch(`${API_BASE_URL}stores`, {
        method: "GET",
        // body: JSON.stringify({
        //   user_id: user?.id,
        // }),
        headers: headers,
        // headers: {
        //   "Content-Type": "application/json",
        //   Authorization: `Bearer ${user.authorisation.token}`,
        // },
      });
      const responseData = await response.json();

      if (responseData.res === true) {
        setAllDetails(responseData.data);
      } else {
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getStoreFavouriteId = store =>
    store?.favourite_id ?? store?.favorite_id ?? store?.liked_store_id ?? null;

  const updateStoreFollowState = (storeId, favouriteId) => {
    setAllDetails(prevStores =>
      (prevStores || []).map(store =>
        Number(store?.id) === Number(storeId)
          ? {
            ...store,
            favourite_id: favouriteId,
            favorite_id: favouriteId,
            liked_store_id: favouriteId,
          }
          : store
      )
    );
  };

  const handleToggleStoreWishlist = async (event, store) => {
    event.preventDefault();
    event.stopPropagation();

    if (!user) {
      $(".loginLink").click(() => {
        $(".loginPopup").addClass("active");
      });
      setOpenModal(!openModal);
      return;
    }

    if (storeWishlistLoadingId) return;

    const storeId = store?.id;
    const previousFavouriteId = getStoreFavouriteId(store);
    const isFollowing = Boolean(previousFavouriteId);

    setStoreWishlistLoadingId(storeId);
    updateStoreFollowState(storeId, isFollowing ? null : "pending");

    try {
      let response;

      if (isFollowing && previousFavouriteId) {
        response = await fetch(`${API_BASE_URL}frontend/liked-stores/${previousFavouriteId}`, {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${user?.authorisation?.token}`,
          },
        });
      } else {
        response = await fetch(`${API_BASE_URL}frontend/liked-stores`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.authorisation?.token}`,
          },
          body: JSON.stringify({ store_id: storeId }),
        });
      }

      const responseData = await response.json();
      if (!responseData?.res) {
        throw new Error(responseData?.msg || "Something went wrong");
      }

      const updatedFavouriteId =
        isFollowing
          ? null
          : responseData?.favourite_id ?? responseData?.data?.favourite_id ?? responseData?.data?.id ?? previousFavouriteId;

      updateStoreFollowState(storeId, updatedFavouriteId);
      if (!isFollowing) {
        NotificationManager.success(responseData?.msg);
      }
    } catch (error) {
      updateStoreFollowState(storeId, previousFavouriteId);
      NotificationManager.warning(error?.message || "Something went wrong");
    } finally {
      setStoreWishlistLoadingId(null);
    }
  };

  const handleRequestPrice = async id => {
    if (!user) {
      $(".loginLink").click(() => {
        $(".loginPopup").addClass("active");
      });
      setOpenModal(!openModal);
    } else {
      try {
        const response = await fetch(`${API_BASE_URL}frontend/request-price`, {
          method: "POST",
          body: JSON.stringify({
            store_id: id,
          }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.authorisation.token}`,
          },
        });
        const responseData = await response.json();
        if (responseData.res === true) {
          // setResponseStatus(responseData?.msg);
          NotificationManager.success(responseData?.msg);
        } else {
          // setResponseStatus(responseData?.msg);
          NotificationManager.warning(responseData?.msg);
        }
      } catch (error) { }
    }
  };

  useEffect(() => {
    fetchStores();
  }, []);

  return (
    <div>
      <Header openModal={openModal} />
      <style>{`body { background: #FFF; }`}</style>

      <div className="fairDiv">
        <div className="fairBanner">
          <h2>
            {langJson?.welcome} {langJson?.to}
          </h2>
          <h2>{SITE_NAME} {langJson?.tradeexhibition}</h2>
        </div>
        <div className="fullContainer">
          <ul className="stores storeNew storeListNew">
            {loading ? (
              Array.from({ length: 12 }).map((_, index) => (
                <li key={index}>
                  <StoreSkeleton />
                </li>
              ))
            ) : allDetails && allDetails.length > 0 ? (
              allDetails?.map((item, index) => (
                <li key={index}>
                  <div className="storeItem" key={index}>
                    <Link to={`/stores/${item?.id}`} state={{ from: location.pathname }}>
                      <div className="storeImgHolder">
                        <div className="storeCardHeart">
                          <StoreHeartIcon
                            active={Boolean(getStoreFavouriteId(item))}
                            onClick={event => handleToggleStoreWishlist(event, item)}
                          />
                        </div>
                        <img className="storeItemImg" src={IMAGE_URL + item?.cover} alt={item?.store_name} />
                      </div>
                      <img className="storeLogo" src={IMAGE_URL + item?.logo} alt={`Store ${index}`} />
                      <h3 className="storeNameBrand">{item?.store_name}</h3>
                    </Link>
                  </div>
                  {/* <div className="boothCard">
                  <img
                    src={fairImg}
                    alt="Booth"
                    className="boothBg"
                  />
                  <div className="boothLogo">
                    <img
                      src={IMAGE_URL + item?.logo}
                      alt=""
                    />
                  </div>
                </div>

                <div className="fairOverlay">
                  <button onClick={() => handleAddStore(item?.id)}>
                    <img src={wishImg} alt="" />
                  </button>
                  <div className="fairBtns">
                    <Link className="viewBtn" to={`/stores/${item?.id}`} state={{ from: location.pathname }}>
                      {langJson?.viewdetails}
                    </Link>
                    <a href="javascript:void(0);" className="prcBtn" onClick={() => handleRequestPrice(item?.id)}>
                      {langJson?.requestforprice}
                    </a>
                  </div>
                </div> */}
                </li>
              ))
            ) : (
              <div className="noItemFoundClass">{langJson?.noitemsfound}</div>
            )}
          </ul>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default FairTrade;
